/*
@TODO
- [ ] Long captions could be cut off with iframes. Unfortunatly you cant use object-fit on iframes.
- [ ] Add option to close overlay by clicking outside of the element
 */

/**
 * @deprecated
 */
export class TheZoombox {
    constructor(containerSelector, options) {
        // ! variables init, DONT USE THIS AS OPTIONS!
        // check if containerSelector is String or Element
        if (typeof containerSelector === 'string') {
            this.container = document.querySelector(containerSelector);
        } else if (containerSelector instanceof Element) {
            this.container = containerSelector;
        } else {
            throw new Error('ContainerSelector must be a string or an Element');
        }
        this.items = [];
        this.activeIndex = 0;
        this.hashChange = true;
        this.initMetaViewport = document.querySelector('meta[name="viewport"]')?.getAttribute('content') ?? '';

        // * OPTIONS
        this.options = {
            identifyBy: 'a', // Bilder werden anhand diesem Selektor identifiziert (z.B. auch a.klasse möglich)
            showPictureCounter: false, // Numerierung anzeigen?
            showNavigation: true, // Steuerung (vor/zurück) aktivieren? Nur bei mehreren Bildern
            keyNavigation: true, // Tastaturnavigation (vor/zurück)
            swipeNavigation: true, // NEU: Gestennavigation (vor/zurück) als Option
            changeHistory: true,
            useMaterialIcons: false,
            showCaption: true, // Untertitel anzeigen?
            useLegacyCaption: false, // if activated the caption will be loaded by title attribute, is disabled by figcaption element in item
            enableZoom: true, // enable zoom on images
            ...options, // merge options with default options
        };

        // ? bindings must be defined in constructor to remove them at close
        // keydown navigation
        this.keydownHandler = this.handleKeyNavigation.bind(this);
        this.documentKeydownHandler = this.keydownHandler.bind(this);
        // swipe navigation
        this.touchstartX = 0;
        this.touchendX = 0;
        this.isSwipeNotPinch = false;
        this.touchStartListener = this.handleTouchStart.bind(this);
        this.touchStartHandler = this.touchStartListener.bind(this);
        this.touchEndListener = this.handleTouchEnd.bind(this);
        this.touchEndHandler = this.touchEndListener.bind(this);

        // Event-Listener for popstate
        if (this.options.changeHistory) {
            window.addEventListener('popstate', () => {
                if (this.hashChange) {
                    if (window.location.href.indexOf('zoom=') != -1) {
                        const matches = window.location.href.match(/zoom=([\da-z-]+)/);
                        if (matches != null && matches[1] != null) {
                            // search in this.items for item with dataUid
                            for (const item of this.items) {
                                if (item.dataUid === matches[1]) {
                                    this.showItem(this.items.indexOf(item));
                                    return;
                                }
                            }
                        }
                    } else {
                        this.hideOverlay();
                    }
                }
            });
        }

        // init
        this.init();
    }

    init() {
        // Elemente sammeln - wie vorher
        this.collectItems();

        // Event-Listener auf dem Container setzen
        this.container.addEventListener('click', this.handleContainerClick.bind(this));

        // init hash check
        if (this.options.changeHistory) {
            if (window.location.href.indexOf('zoom=') != -1) {
                const matches = window.location.href.match(/zoom=([\da-z\-]+)/);
                if (matches != null && matches[1] != null) {
                    // search in this.items for item with dataUid
                    for (const item of this.items) {
                        if (item.dataUid === matches[1]) {
                            this.showItem(this.items.indexOf(item));
                            return;
                        }
                    }
                }
            } else {
                this.hideOverlay();
            }
        }

        this.container.classList.add('the-zoombox--initialized');
    }

    collectItems() {
        let itemEls = this.container.matches(this.options.identifyBy) ? this.container : this.container.querySelectorAll(this.options.identifyBy);

        if (itemEls) {
            // Sicherstellen, dass itemEls etwas enthält
            if (!Array.isArray(itemEls) && itemEls.nodeType) {
                // Ein einzelnes Element wurde gefunden: in ein Array umwandeln
                itemEls = [itemEls];
            }

            for (const itemEl of itemEls) {
                // skip items without href
                if (!itemEl.href) continue;

                // * type
                const type = determineItemType(itemEl.href);

                // * data-uid
                // get data-uid from item. if no data-uid exists create a unique id
                const dataUid = itemEl.getAttribute('data-uid') ?? crypto.randomUUID();
                // set data-uid to item
                itemEl.setAttribute('data-uid', dataUid);

                // * caption
                // load caption from title attribute if useLegacyCaption is true
                // else load caption from figcaption element inside of item
                let caption = '';
                if (this.options.useLegacyCaption) {
                    caption = itemEl.getAttribute('title') ?? '';
                } else {
                    const figcaptionEl = itemEl.querySelector('figcaption');
                    if (figcaptionEl) {
                        // get html in figcaption element
                        caption = figcaptionEl.innerHTML;
                    }
                }

                // * download
                const download = itemEl.getAttribute('data-download') ?? '';

                this.items.push({
                    type: type,
                    dataUid: dataUid,
                    src: itemEl.getAttribute('href'),
                    caption: caption,
                    download: download,
                });
            }
        } else {
            console.error('The Zoombox: No items found');
        }

        // if this.items <= 1 disable navigation
        if (this.items.length <= 1) {
            this.options.showNavigation = false;
            this.options.keyNavigation = false;
            this.options.swipeNavigation = false;
        }
    }

    createOverlay() {
        blockScrolling();

        const closeIcon = this.options.useMaterialIcons ? `<i class="material-icons">close</i>` : '✕';
        const downloadIcon = this.options.useMaterialIcons ? `<i class="material-icons">download</i>` : '↓';
        const prevIcon = this.options.useMaterialIcons ? `<i class="material-icons">chevron_left</i>` : '‹';
        const nextIcon = this.options.useMaterialIcons ? `<i class="material-icons">chevron_right</i>` : '›';

        const zoomboxCaptionHTML = this.options.showCaption ? `<div class="zoombox-caption"></div>` : '';

        const zoomboxCounterHTML = this.options.showPictureCounter ? `<div class="zoombox-counter"></div>` : '';

        this.overlay = document.createElement('div');
        this.overlay.classList.add('zoombox-overlay');
        this.overlay.innerHTML = `
      <div class="zoombox-content">
            <div class="zoombox-element"></div>
            ` + zoomboxCaptionHTML + zoomboxCounterHTML + `
      </div>
      <div class="zoombox-topbar-interactions">
            <a href="" class="zoombox-download" target="_self" download>` + downloadIcon + `</a>
            <button class="zoombox-close">` + closeIcon + `</button>
      </div>
    `;
        // extend overlay innerhtml with navigation
        if (this.options.showNavigation) {
            this.overlay.innerHTML += `
        <button class="zoombox-prev">` + prevIcon + `</button>
        <button class="zoombox-next">` + nextIcon + `</button>
      `;
        }

        document.body.appendChild(this.overlay);
    }

// Neuer Event Handler, der Klicks im Container abfängt
    handleContainerClick(event) {
        event.preventDefault();

        // Closest-Element ermitteln, das dem Selektor entspricht
        const closestItem = this.getClosestItem(event.target);

        if (closestItem) {
            // get data-uid from closestItem
            const closestItemUid = closestItem.getAttribute('data-uid');
            // search for dataUid in items and get index
            const index = this.items.findIndex((item) => item.dataUid === closestItemUid);

            this.showItem(index);
            // Aktualisierung der Hash-URL
            this.updateUrlHash();
        }
    }

    // Hilfsfunktion, um den Item-Link für 'target' zu finden
    getClosestItem(target) {
        while (target && !target.matches(this.options.identifyBy)) {
            target = target.parentElement;
        }
        return target;
    }

    bindOverlayEvents() {
        this.overlay.querySelector('.zoombox-close')?.addEventListener('click', () => {
            this.hideOverlay();
        });

        this.overlay.querySelector('.zoombox-prev')?.addEventListener('click', () => {
            this.showItem(this.activeIndex - 1);
            // Aktualisierung der Hash-URL
            this.updateUrlHash();
        });

        this.overlay.querySelector('.zoombox-next')?.addEventListener('click', () => {
            this.showItem(this.activeIndex + 1);
            // Aktualisierung der Hash-URL
            this.updateUrlHash();
        });

        if (this.options.swipeNavigation) {
            this.overlay.querySelector('.zoombox-content')?.addEventListener('touchstart', (event) => {
                // check if target is not an image
                if (event.target.tagName !== 'IMG') {
                    this.touchstartX = event.changedTouches[0].screenX;
                    this.isSwipeNotPinch = true;
                }
            });

            this.overlay.querySelector('.zoombox-content')?.addEventListener('touchend', (event) => {
                // check if target is not an image
                if (this.isSwipeNotPinch) {
                    this.touchendX = event.changedTouches[0].screenX;
                    this.handleGesture();
                }
                this.isSwipeNotPinch = false;
            });
        }

        // Keyboard navigation
        document.addEventListener('keydown', this.documentKeydownHandler);

        if (this.options.swipeNavigation) {
            //const touchElement = this.overlay.querySelector('.zoombox-element');

            //touchElement.addEventListener('touchstart', this.touchStartHandler);
            //touchElement.addEventListener('touchend', this.touchEndHandler);
        }
    }

    handleKeyNavigation(event) {
      const activeElement = document.activeElement;
      const isInputField = ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName);

      const actions = {
            'Escape': this.hideOverlay,
            'ArrowLeft': () => {
                if (this.options.keyNavigation && !isInputField) {
                    this.showItem(this.activeIndex - 1);
                    // Aktualisierung der Hash-URL
                    this.updateUrlHash();
                }
            },
            'ArrowRight': () => {
                if (this.options.keyNavigation && !isInputField) {
                    this.showItem(this.activeIndex + 1);
                    // Aktualisierung der Hash-URL
                    this.updateUrlHash();
                }
            },
        };

        const action = actions[event.key];
        if (action) {
            action.call(this);  // Execute the mapped action, passing 'this'
        }
    }

    handleTouchStart(event) {
        const isZoomed = this.options.enableZoom;

        if (!isZoomed) {
            this.touchstartX = event.changedTouches[0].screenX;
        } else {
            // reset touchstartX and touchendX
            this.touchstartX = 0;
            this.touchendX = 0;
        }
    }

    handleTouchEnd(event) {
        const isZoomed = this.options.enableZoom;

        if (!isZoomed) {
            this.touchendX = event.changedTouches[0].screenX;
            this.handleGesture();
        } else {
            // reset touchstartX and touchendX
            this.touchstartX = 0;
            this.touchendX = 0;
        }
    }

    handleGesture() {
        if (this.touchendX < this.touchstartX - 100) {
            // Swipe left
            this.showItem(this.activeIndex + 1);
            // Aktualisierung der Hash-URL
            this.updateUrlHash();
        }
        if (this.touchendX > this.touchstartX + 100) {
            // Swipe right
            this.showItem(this.activeIndex - 1);
            // Aktualisierung der Hash-URL
            this.updateUrlHash();
        }
        // reset touchstartX and touchendX
        this.touchstartX = 0;
        this.touchendX = 0;
    };

    showItem(index) {
        if (index >= this.items.length) index = 0;
        if (index < 0) index = this.items.length - 1;

        this.activeIndex = index;
        const item = this.items[index];

        // set meta viewport to no scale
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');

        // Overlay-Struktur erstellen, falls noch nicht vorhanden
        if (!this.overlay) {
            this.createOverlay();
            this.bindOverlayEvents();
        }

        // Je nach Elementtyp den Inhalt dynamisch laden
        switch (item.type) {
            case 'image':
                this.renderImage(item);
                break;
            case 'video':
                this.renderVideo(item);
                break;
            case 'videoIframe':
                this.renderVideoIframe(item);
                break;
            default:
                console.error(`Unsupported item type: ${item.type}`);
        }

        // update caption
        const captionEl = this.overlay.querySelector('.zoombox-caption');
        if (captionEl) {
            if (item.caption) {
                captionEl.innerHTML = sanitizeHtml(item.caption);
                // remove display block if set
                captionEl.classList.remove('zoombox-helper-hide');
            } else {
                // hide caption
                captionEl.classList.add('zoombox-helper-hide');
            }
        }

        // update counter
        const counterEl = this.overlay.querySelector('.zoombox-counter');
        if (counterEl) {
            if (this.options.showPictureCounter) {
                counterEl.textContent = `${index + 1} / ${this.items.length}`;
            } else {
                counterEl.remove();
            }
        }

        // update download link
        const downloadEl = this.overlay.querySelector('.zoombox-download');
        if (downloadEl) {
            if (item.download !== null && item.download !== '' && typeof item.download != 'undefined') {
                downloadEl.setAttribute('href', item.download);
                downloadEl.classList.remove('zoombox-helper-hide');
            } else {
                downloadEl.classList.add('zoombox-helper-hide');
            }
        }
    }

    updateUrlHash() {
        if (this.items[this.activeIndex] && this.options.changeHistory) {
            this.hashChange = false;

            // get query parameter from url
            const urlParams = new URLSearchParams(window.location.search);
            // remove zoom query parameter if exists
            urlParams.delete('zoom');
            // add new zoom query parameter
            urlParams.set('zoom', this.items[this.activeIndex].dataUid);
            // set new url
            const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
            window.history.pushState({}, '', newUrl);

            this.hashChange = true;
        }
    }

    renderImage(item) {
        const imageElement = document.createElement('img');
        imageElement.src = item.src;
        imageElement.alt = item.dataUid;
        const zoomboxElement = this.overlay.querySelector('.zoombox-element');
        zoomboxElement.innerHTML = '';
        zoomboxElement.appendChild(imageElement);
        if (this.options.enableZoom) {
            pinchZoom(imageElement);
        }
    }

    renderVideo(item) {
        const videoContainer = this.overlay.querySelector('.zoombox-element'); // Oder ein geeignenetes Element
        videoContainer.innerHTML = `
          <video src="${item.src}" controls autoplay></video>
      `;
    }

    renderVideoIframe(item) {
        const videoContainer = this.overlay.querySelector('.zoombox-element'); // Passen Sie den Selektor an Ihr Layout an
        const iframe = document.createElement('iframe');

        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', 'true');

        if (isYouTubeUrl(item.src)) {
            iframe.setAttribute('src', `https://www.youtube.com/embed/${getYouTubeVideoId(item.src)}`);
        } else if (isVimeoUrl(item.src)) {
            iframe.setAttribute('src', `https://player.vimeo.com/video/${getVimeoVideoId(item.src)}`);
        }

        // wrap iframe in div.video-container
        const videoWrapper = document.createElement('div');
        videoWrapper.classList.add('video-container');
        videoWrapper.appendChild(iframe);

        // wrap videoWrapper with div.iframe-wrapper
        const iframeWrapper = document.createElement('div');
        iframeWrapper.classList.add('iframe-wrapper');
        iframeWrapper.appendChild(videoWrapper);

        videoContainer.innerHTML = ''; // Leeren Sie den Container, bevor Sie das iframe einfügen
        videoContainer.appendChild(iframeWrapper);
    }

    hideOverlay() {
        if (!this.overlay) {
            return;
        }

        // set meta viewport to initial
        document.querySelector('meta[name="viewport"]').setAttribute('content', this.initMetaViewport);

        document.removeEventListener('keydown', this.documentKeydownHandler);

        if (this.options.swipeNavigation) {
            //const touchElement = this.overlay.querySelector('.zoombox-element');

            //touchElement.removeEventListener('touchstart', this.touchStartHandler);
            //touchElement.removeEventListener('touchend', this.touchEndHandler);
        }

        // remove overlay
        this.overlay.remove();
        // unset this.overlay
        this.overlay = null;

        // Entfernen der Hash-URL
        if (this.options.changeHistory) {
            this.hashChange = false;

            // search for zoom query parameter in url and remove it
            const url = window.location.href;
            const urlWithoutZoom = url.replace(/(\?|&)zoom=[^&]+/g, '');
            window.history.pushState({}, '', urlWithoutZoom);
            this.hashChange = true;
        }

        unblockScrolling();

        if (this.options.afterClose && typeof this.options.afterClose == 'function') {
            this.options.afterClose();
        }
    }
}

// Hilfsfunktion bestimmen ItemType based on file extensions
function determineItemType(href) {
    const filename = href.split('/').pop();
    const extension = filename.split('.').pop().toLowerCase(); // Extrahiere Extension

    switch (extension) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'webp':
        case 'svg':
            return 'image';
        case 'mp4':
        case 'webm':
            return 'video';
        default:
            // YouTube- und Vimeo-URLs prüfen
            if (isYouTubeUrl(href)) {
                return 'videoIframe';
            } else if (isVimeoUrl(href)) {
                return 'videoIframe';
            } else {
                console.error(`Unsupported file type: ${extension}`);
                return null;
            }
    }
}

// Hilfsfunktionen zur Erkennung von YouTube- und Vimeo-URLs
function isYouTubeUrl(href) {
    return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(.+)\/?/.test(href);
}

function isVimeoUrl(href) {
    return /^(https?:\/\/)?(www\.)?vimeo\.com\/(\d+)\/?/.test(href);
}

// Hilfsfunktionen zur Extraktion der Video-ID
function getYouTubeVideoId(url) {
    const match = url.match(/v=([^\&]+)/);
    return match && match[1];
}

function getVimeoVideoId(url) {
    const match = url.match(/\/(\d+)[/]?/);
    return match && match[1];
}

function sanitizeHtml(htmlString) {
    // Entfernen von Skript-Tags
    const regexScript = /<script.*?>.*?<\/script>/g;
    htmlString = htmlString.replace(regexScript, '');

    // Entfernen von Event-Handlern
    const regexEventHandlers = /on\w+=".*?"/g;
    htmlString = htmlString.replace(regexEventHandlers, '');

    // Entfernen von Attributen mit JavaScript-Ausdrücken
    const regexAttributes = /([a-z]+)=".*?javascript:.*?"/g;
    htmlString = htmlString.replace(regexAttributes, '$1=""');

    // Entfernen von unsicheren Tags
    const unsafeTags = ['iframe', 'object', 'embed', 'applet'];
    for (const tag of unsafeTags) {
        const regexTag = new RegExp(`<${tag}(.*?)>.*?</${tag}>`, 'g');
        htmlString = htmlString.replace(regexTag, '');
    }

    return htmlString;
}

const pinchZoom = async (imageElement, options = {}) => {
    const {maxScale = 3, acceleration = 1} = options; // Destructure options object
    let imageElementScale = 1;
    let deltaX;
    let deltaY;
    let start = {
        x: 0,
        y: 0,
        distance: 0,
        lastX: 0,
        lastY: 0,
        lastScale: 1,
    };
    let isAnimating = false;
    let isPaning = false;
    let isPinching = false;

    // get imageElement dimensions
    let newImageElementClientRect = await getImageElementSizeLoaded(imageElement);
    const imageElementClientRect = await getImageElementSizeLoaded(imageElement);

    // debug
    const showDebugSquare = false;
    if (showDebugSquare) {
        const imageElementWidth = imageElementClientRect.width;
        const imageElementHeight = imageElementClientRect.height;
        const imageElementTop = imageElementClientRect.top;
        const imageElementLeft = imageElementClientRect.left;

        // width after scale
        //console.log(imageElementClientRect);

        // create debug overlay
        document.querySelector('body').style.position = 'relative';

        const debugRect = document.createElement('div');
        debugRect.style.background = 'rgb(255 0 0 / 30%)';
        debugRect.style.height = imageElementHeight + 'px';
        debugRect.style.width = imageElementWidth + 'px';
        debugRect.style.position = 'absolute';
        debugRect.style.zIndex = '9999';
        debugRect.style.top = imageElementTop + 'px';
        debugRect.style.left = imageElementLeft + 'px';
        debugRect.style.pointerEvents = 'none';
        document.querySelector('body').append(debugRect);
    }

    // Calculate distance between two fingers
    const distance = (event) => {
        return Math.hypot(
            event.touches[0].pageX - event.touches[1].pageX,
            event.touches[0].pageY - event.touches[1].pageY,
        );
    };

    imageElement.addEventListener('touchstart', (event) => {
        // console.log('touchstart', event);
        if (event.touches.length === 1 && !isAnimating && !isPinching) {
            event.preventDefault(); // Prevent page scroll

            isPaning = true;

            start.x = event.touches[0].pageX;
            start.y = event.touches[0].pageY;
        } else if (event.touches.length === 2 && !isAnimating) {
            event.preventDefault(); // Prevent page scroll

            isPinching = true;
            isPaning = false;

            // Calculate where the fingers have started on the X and Y axis
            start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
            start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
            start.distance = distance(event);
        }
    });

    imageElement.addEventListener('touchmove', (event) => {
        // console.log('touchmove', event);
        if (event.touches.length === 1 && isPaning && !isAnimating && !isPinching) {
            event.preventDefault(); // Prevent page scroll

            imageElementScale = Math.min(
                Math.max(0.1, parseFloat(start.lastScale)),
                maxScale,
            );

            // Calculate how much the fingers have moved on the X and Y axis
            deltaX =
                (event.touches[0].pageX - start.x) *
                acceleration;
            deltaX += start.lastX;
            deltaY =
                (event.touches[0].pageY - start.y) *
                acceleration;
            deltaY += start.lastY;

            // Transform the image to make it grow and move with fingers
            const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
            imageElement.style.transform = transform;
            imageElement.style.WebkitTransform = transform;
            imageElement.style.zIndex = '9999';
        } else if (event.touches.length === 2 && isPinching && !isAnimating) {
            event.preventDefault(); // Prevent page scroll

            // Safari provides event.scale as two fingers move on the screen
            // For other browsers just calculate the scale manually
            let scale;
            if (event.scale) {
                scale = event.scale;
            } else {
                const deltaDistance = distance(event);
                scale = deltaDistance / start.distance;
            }
            imageElementScale = Math.min(
                Math.max(0.1, parseFloat(start.lastScale) + parseFloat(scale) - 1),
                maxScale,
            );

            // Calculate how much the fingers have moved on the X and Y axis
            deltaX =
                ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) *
                acceleration;
            deltaX += start.lastX;
            deltaY =
                ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) *
                acceleration;
            deltaY += start.lastY;

            // Transform the image to make it grow and move with fingers
            const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
            imageElement.style.transform = transform;
            imageElement.style.WebkitTransform = transform;
            imageElement.style.zIndex = '9999';
        }
    });

    imageElement.addEventListener('touchend', (event) => {
        if (isPinching || isPaning) {
            start.lastScale = imageElementScale;
            start.lastX = deltaX;
            start.lastY = deltaY;

            if (event.touches.length === 0 && !isAnimating) {
                newImageElementClientRect = imageElement.getBoundingClientRect();

                let xCorrection = null;
                let yCorrection = null;

                // Wenn das Bild zu weit herausgezoomt ist, zurücksetzen
                if (start.lastScale < 1) {
                    // Reset to original size and position
                    start.lastScale = 1;
                    xCorrection = 0;
                    yCorrection = 0;
                } else {
                    if (
                        imageElementClientRect.left < newImageElementClientRect.left &&
                        imageElementClientRect.right < newImageElementClientRect.right
                    ) {
                        const correction =
                            (imageElementClientRect.width * (start.lastScale - 1)) / 2;
                        xCorrection = correction.toFixed();
                    } else if (
                        imageElementClientRect.left > newImageElementClientRect.left &&
                        imageElementClientRect.right > newImageElementClientRect.right
                    ) {
                        const correction =
                            (imageElementClientRect.width * (start.lastScale - 1)) / 2;
                        xCorrection = -correction.toFixed();
                    }

                    if (
                        imageElementClientRect.top < newImageElementClientRect.top &&
                        imageElementClientRect.bottom < newImageElementClientRect.bottom
                    ) {
                        const correction =
                            (imageElementClientRect.height * (start.lastScale - 1)) / 2;
                        yCorrection = correction.toFixed();
                    } else if (
                        imageElementClientRect.top > newImageElementClientRect.top &&
                        imageElementClientRect.bottom > newImageElementClientRect.bottom
                    ) {
                        const correction =
                            (imageElementClientRect.height * (start.lastScale - 1)) / 2;
                        yCorrection = -correction.toFixed();
                    }
                }

                if (xCorrection !== null || yCorrection !== null) {
                    isAnimating = true;
                    const animationDuration = 200;
                    const animateToX = parseFloat(
                        xCorrection !== null ? xCorrection : start.lastX,
                    );
                    const animateToY = parseFloat(
                        yCorrection !== null ? yCorrection : start.lastY,
                    );

                    imageElement.style.transition =
                        'transform ' + animationDuration + 'ms ease';
                    const transform = `translate3d(${animateToX}px, ${animateToY}px, 0) scale(${start.lastScale})`;
                    imageElement.style.transform = transform;
                    imageElement.style.WebkitTransform = transform;
                    setTimeout(() => {
                        isAnimating = false;
                        imageElement.style.transition = null;
                        start.lastX = animateToX;
                        start.lastY = animateToY;
                    }, animationDuration + 10);
                }
                isPinching = false;
                isPaning = false;
            }
        }
    });
};

function getImageElementSizeLoaded(imageElement) {
    return new Promise((resolve, reject) => {
        if (imageElement.complete) {
            setTimeout(() => {
                const sizes = imageElement.getBoundingClientRect();

                resolve({
                    width: sizes.width,
                    height: sizes.height,
                    top: sizes.top,
                    left: sizes.left,
                    right: sizes.right,
                    bottom: sizes.bottom,
                });
            }, 10);
        } else {
            imageElement.onload = () => {
                setTimeout(() => {
                    const sizes = imageElement.getBoundingClientRect();

                    resolve({
                        width: sizes.width,
                        height: sizes.height,
                        top: sizes.top,
                        left: sizes.left,
                        right: sizes.right,
                        bottom: sizes.bottom,
                    });
                }, 10);
            };
            imageElement.onerror = reject;
        }
    });
}

export const blockScrolling = (scrollElement = document.scrollingElement) => {
    const scrollOffset = window.scrollY;

    // check if scrollElement has a scrollbar
    const hasScrollbar = scrollElement.scrollHeight > scrollElement.clientHeight;

    scrollElement.style.overflow = 'hidden';
    scrollElement.style.position = 'fixed';
    scrollElement.style.width = '100%';
    scrollElement.style.top = -scrollOffset + 'px';
    scrollElement.style.overflowY = hasScrollbar ? 'scroll' : 'hidden';
};

export const unblockScrolling = (scrollElement = document.scrollingElement) => {
    const scrollOffset = parseInt(scrollElement.style.top, 10);

    scrollElement.style.removeProperty('position');
    scrollElement.style.removeProperty('overflow');
    scrollElement.style.removeProperty('width');
    scrollElement.style.removeProperty('top');

    window.scrollTo(0, -scrollOffset);
};
